export default __webpack_public_path__ + "static/media/922917a9-4ca8-4c0b-b1bb-417b6ff0210e.74de1f3e.ttf";